import { render, staticRenderFns } from "./Media.vue?vue&type=template&id=60bb07ac&scoped=true"
import script from "./Media.vue?vue&type=script&lang=js"
export * from "./Media.vue?vue&type=script&lang=js"
import style0 from "./Media.vue?vue&type=style&index=0&id=60bb07ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bb07ac",
  null
  
)

export default component.exports